import { ApplicationState } from 'application/redux';
import { connect } from 'react-redux';
import changeTab from './redux/actions';
import RfTuningComponent from './rf-tuning-component';

function mapStateToProps(state: ApplicationState, ownProps: any) {
  return {
    currentTab: state.devices.detail.rfTuning.main.currentTab,
    currentFrequencyTab: state.devices.detail.rfTuning.status.currentFrequencyTab,
    hhid: ownProps.hhid,
    id: ownProps.id,
    frequencyLimits: state.devices.detail.rfTuning.status.frequencyLimits,
  };
}

export default connect(mapStateToProps, { changeTab })(RfTuningComponent);
